import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Component/Footer";
import Wsp from "../../contact/Component/Floatingwsp";
import { hasSubmittedToday, markSubmittedToday, DUPLICATE_LEAD_MESSAGE } from "../../../Common/leadDedupe";
import "./Enquiry.css";

const models = ["Seltos", "Sonet", "Carens", "EV6", "Carnival", "EV9", "Syros", "Syros EV", "Sorento"];

const whyEnquire = [
  { num: "01", title: "Expert Consultation", desc: "Our Kia-certified consultants walk you through every model, variant, and feature — zero pressure, pure guidance." },
  { num: "02", title: "Best Price Promise", desc: "Get the most competitive on-road price with transparent breakdown, exclusive offers, and zero hidden charges." },
  { num: "03", title: "Home Test Drive", desc: "Can't visit? We bring the car to you. Book a test drive at your doorstep at a time that suits you." },
  { num: "04", title: "Easy Financing", desc: "Flexible EMI options, instant loan approvals, and dedicated finance support to make ownership effortless." },
];

const Enquiry = (props) => {
  const [name,   setName]   = useState("");
  const [mobile, setMobile] = useState("");
  const [email,  setEmail]  = useState("");
  const [city,   setCity]   = useState("");
  const [model,  setModel]  = useState("");
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitting) return;
    const errs = {};
    if (!name)   errs.name   = "Name is required.";
    if (!mobile) errs.mobile = "Mobile number is required.";
    if (!city)   errs.city   = "City is required.";
    if (!model)  errs.model  = "Please select a model.";
    if (hasSubmittedToday(mobile)) errs.mobile = DUPLICATE_LEAD_MESSAGE;
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    setSubmitting(true);
    props.AddEnquiryForm(name, mobile, email, city, model);
    markSubmittedToday(mobile);
    setName(""); setMobile(""); setEmail(""); setCity(""); setModel("");
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3500);
    setTimeout(() => setSubmitting(false), 3500);
  };

  return (
    <div className="enq-root">

      {/* ── HERO ── */}
      <section className="enq-hero">
        <div
          className="enq-hero__bg"
          style={{
            backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/featureData%2Fmgcentralintr.jpeg?alt=media&token=fc24a189-bb82-410a-9bd5-7c14ab0ee4f3)`,
          }}
        />
        <div className="enq-hero__overlay" />
        <div className="enq-hero__content">
          <span className="enq-hero__eyebrow">Kia Central — Bhubaneswar</span>
          <h1 className="enq-hero__title">Your Kia Journey<br />Starts Here</h1>
          <p className="enq-hero__desc">
            Fill in your details below and our expert will get in touch within 24 hours.
          </p>
        </div>
      </section>

      {/* ── WHY ENQUIRE ── */}
      <section className="enq-why">
        <div className="enq-why__inner">
          <div className="enq-why__head">
            <span className="enq-tag">Why Enquire With Us</span>
            <h2 className="enq-section-title">The Central Kia Advantage</h2>
          </div>
          <div className="enq-why__grid">
            {whyEnquire.map((item) => (
              <div className="enq-why__card" key={item.num}>
                <span className="enq-why__num">{item.num}</span>
                <h3 className="enq-why__card-title">{item.title}</h3>
                <p className="enq-why__card-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FORM SECTION ── */}
      <section className="enq-form-section">
        <div className="enq-form-left">
          <span className="enq-tag enq-tag--light">Book a Consultation</span>
          <h2 className="enq-form-heading">Enquiry Form</h2>
          <p className="enq-form-sub">
            Share your details and we'll connect you with the right Kia for your lifestyle and budget.
          </p>

          <ul className="enq-form-promises">
            <li>No spam, ever</li>
            <li>Response within 24 hours</li>
            <li>Dedicated consultant assigned</li>
          </ul>
        </div>

        <div className="enq-form-card">
          {submitted && (
            <div className="enq-success">
              Thank you! Our team will reach out within 24 hours.
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            {/* Name + Mobile */}
            <div className="enq-field-row">
              <div className="enq-field">
                <label className="enq-label">Name <sup className="enq-req">*</sup></label>
                <input
                  className={`enq-input${errors.name ? " enq-input--err" : ""}`}
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {errors.name && <span className="enq-err">{errors.name}</span>}
              </div>
              <div className="enq-field">
                <label className="enq-label">Mobile No. <sup className="enq-req">*</sup></label>
                <input
                  className={`enq-input${errors.mobile ? " enq-input--err" : ""}`}
                  placeholder="Enter mobile number"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                />
                {errors.mobile && <span className="enq-err">{errors.mobile}</span>}
              </div>
            </div>

            {/* Email + City */}
            <div className="enq-field-row">
              <div className="enq-field">
                <label className="enq-label">Email ID</label>
                <input
                  className="enq-input"
                  type="email"
                  placeholder="Enter email (optional)"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="enq-field">
                <label className="enq-label">City <sup className="enq-req">*</sup></label>
                <input
                  className={`enq-input${errors.city ? " enq-input--err" : ""}`}
                  placeholder="Your city"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
                {errors.city && <span className="enq-err">{errors.city}</span>}
              </div>
            </div>

            {/* Model */}
            <div className="enq-field enq-field--full">
              <label className="enq-label">Select Model <sup className="enq-req">*</sup></label>
              <div className="enq-model-grid">
                {models.map((m) => (
                  <button
                    type="button"
                    key={m}
                    className={`enq-model-chip${model === m ? " enq-model-chip--active" : ""}`}
                    onClick={() => setModel(m)}
                  >
                    {m}
                  </button>
                ))}
              </div>
              {errors.model && <span className="enq-err">{errors.model}</span>}
            </div>

            {/* Submit */}
            <div className="enq-form-footer">
              <button type="submit" className="enq-submit" disabled={submitting}>
                {submitting ? "Submitting..." : <>Submit Enquiry &rarr;</>}
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* ── STATS STRIP ── */}
      <section className="enq-stats">
        {[
          { num: "5K+",  label: "Happy Customers" },
          { num: "8+",   label: "Showrooms in Odisha" },
          { num: "24h",  label: "Response Guarantee" },
          { num: "12+",  label: "Years of Trust" },
        ].map((s) => (
          <div className="enq-stats__item" key={s.label}>
            <span className="enq-stats__num">{s.num}</span>
            <span className="enq-stats__label">{s.label}</span>
          </div>
        ))}
      </section>

      {/* ── CTA BAND ── */}
      <section className="enq-cta">
        <div className="enq-cta__inner">
          <h2 className="enq-cta__title">Prefer to Talk Directly?</h2>
          <p className="enq-cta__body">
            Call us or walk into our showroom — our consultants are available 7 days a week.
          </p>
          <div className="enq-cta__btns">
            <a href={`tel:+91${process.env.REACT_APP_CONTACT_PHONE}`} className="enq-cta__btn enq-cta__btn--white">
              Call Now
            </a>
            <Link to="/contact" className="enq-cta__btn enq-cta__btn--ghost">
              Visit Showroom
            </Link>
          </div>
        </div>
      </section>

      <Wsp />
    </div>
  );
};

export default Enquiry;